import React from 'react';
import { Typography, Row } from 'antd';
import styles from './styles/popup.module.css';
import store from '@/store/store';
import { hidePopupMessage, showChatbotWithDelay } from '@/store/slices/chatbotVisibility';

const { Paragraph, Text } = Typography;

const PopupLayout = (props) => {
  const { popupSize, visible, color, textColor, avatar, headerTitle, message, position } = props;

  if (!visible) return null;

  let containerSize;
  let maxRows;
  let marginBottom;
  let messagePaddingTop;

  switch (popupSize) {
    case 'SMALL':
      containerSize = styles.small;
      maxRows = 2;
      marginBottom = '5px';
      messagePaddingTop = '15px';
      break;
    case 'LARGE':
      containerSize = styles.large;
      maxRows = 6;
      marginBottom = '20px';
      messagePaddingTop = '20px';
      break;
    default:
      containerSize = styles.medium;
      maxRows = 4;
      marginBottom = '15px';
      messagePaddingTop = '20px';
  }

  return (
    <div
      className={[
        styles.container,
        containerSize,
        position === 'left' ? styles.left : styles.right,
      ].join(' ')}
    >
      <Row
        style={{
          backgroundColor: color,
          borderRadius: '10px 10px 0 0',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'nowrap'
        }}
      >
        <div className={styles.avatar}>
          <img className={styles.image} src={avatar} alt="chatbot-logo" />
        </div>
        <div className={styles.topSection}>
          <Text className={[styles.white, styles.title].join(' ')}>
            {headerTitle}
          </Text>
        </div>
      </Row>
      <div className={styles.message}>
        <Paragraph
          style={{ color: textColor, margin: 0, padding: `${messagePaddingTop} 20px 45px 20px` }}
          ellipsis={{ rows: maxRows, expandable: false }}
        >
          {message}
        </Paragraph>
        <Text
          style={{
            color: color,
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            position: 'absolute',
            right: '20px',
            bottom: marginBottom,
          }}
          onClick={(e) => {
            e.stopPropagation();
            store.dispatch(hidePopupMessage());
            store.dispatch(showChatbotWithDelay(5));
          }}
          strong
        >
          Get Started
        </Text>
      </div>
    </div>
  );
};

export default PopupLayout;
